
module.exports = {
    REQUEST_POST: 'REQUEST_POST',
    RECEIVE_POST: 'RECEIVE_POST',
    REQUEST_POST_FAILURE: 'REQUEST_POST_FAILURE',

    SET_POST: 'SET_POST',

    REQUEST_POST_LIST: 'REQUEST_POST_LIST',
    RECEIVE_POST_LIST: 'RECEIVE_POST_LIST',
    REQUEST_POST_LIST_FAILURE: 'REQUEST_POST_LIST_FAILURE'
};



// WEBPACK FOOTER //
// ./src/common/modules/posts/constants.js